import clsx from 'clsx'

export default function Microcopy({ text, className }: { text: string; className?: string }) {
  return (
    <span className={clsx(className ?? undefined, 'inline-block text-sm text-eo-beautifly text-center font-semibold mt-4')}>{text}</span>
  )
}
